import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/codegen/form/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/codegen/form',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/codegen/form/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/codegen/form/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/codegen/form',
    method: 'put',
    data: obj
  })
}
